import React, { useEffect, useState } from 'react';
import './select-tag.less';
import IconFont from '@meitu/xdesign-icon-font';

export interface ISelectTypeListItem {
    name: string;
    theme?: string;
    list: { name: string; isSelect: boolean }[];
}

const SelectTag: React.FC<{
    selectTypeList: ISelectTypeListItem[];
    setSelectTypeList: (selectTypeList: ISelectTypeListItem[]) => void;
}> = ({ selectTypeList, setSelectTypeList }) => {
    const [selectType, setSelectType] = useState(selectTypeList[0]?.name || '');

    const selectTypeClick = (name: string) => {
        setSelectType(name);
    };

    useEffect(() => {
        if (selectType === '' && selectTypeList.length > 0) {
            setSelectType(selectTypeList[0].name);
        }
    }, [selectTypeList, selectType]);

    const selectTagName = (name: string) => {
        const typeItem = selectTypeList.find((item) => item.name === selectType);
        const tagItem = typeItem?.list.find((item) => item.name === name);
        if (tagItem) {
            const isSelect = !tagItem.isSelect;
            typeItem?.list.forEach((item) => (item.isSelect = false));
            tagItem.isSelect = isSelect;
        }
        setSelectTypeList([...selectTypeList]);
    };

    const removeSelectItem = (typeName: string, itemName: string) => {
        const typeItem = selectTypeList.find((item) => item.name === typeName);
        const tagItem = typeItem?.list.find((item) => item.name === itemName);
        if (tagItem) {
            tagItem.isSelect = !tagItem.isSelect;
        }
        setSelectTypeList([...selectTypeList]);
    };

    return (
        <div className="pptMark-selectTag">
            <div className="selected-tag">
                {selectTypeList.map((typeItem) => {
                    return (
                        <div className="selected-tag-item" key={typeItem.name}>
                            <span>{typeItem.name}: </span>
                            {typeItem.list
                                .filter((type) => type.isSelect)
                                .map((item) => {
                                    return (
                                        <div className="tagItem" key={item.name}>
                                            <span>
                                                {item.name.includes('次中性色')
                                                    ? item.name.replace('次中性色', '主题内容色')
                                                    : item.name}
                                            </span>
                                            <IconFont
                                                onClick={() => {
                                                    removeSelectItem(typeItem.name, item.name);
                                                }}
                                                name="CrossBlack"
                                                color="rgba(147, 149, 153, 1)"
                                                fontSize={12}
                                            ></IconFont>
                                        </div>
                                    );
                                })}
                        </div>
                    );
                })}
            </div>

            <div className="tag-list-wrap">
                <div className="tag-tab">
                    {selectTypeList.map((item) => {
                        return (
                            <span
                                key={item.name}
                                className={`${item.name === selectType ? 'active' : ''}`}
                                onClick={() => {
                                    selectTypeClick(item.name);
                                }}
                            >
                                {item.theme
                                    ? item.theme
                                    : item.name.includes('次中性色')
                                      ? item.name.replace('次中性色', '主题内容色')
                                      : item.name}
                            </span>
                        );
                    })}
                </div>
                <div className="tag-list">
                    {(selectTypeList.find((item) => item.name === selectType)?.list || []).map((item) => {
                        return (
                            <span
                                key={item.name}
                                className={`${item.isSelect ? 'active' : ''}`}
                                onClick={() => selectTagName(item.name)}
                            >
                                {item.name.includes('次中性色')
                                    ? item.name.replace('次中性色', '主题内容色')
                                    : item.name}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SelectTag;
